import React from "react";

import { Icon, type IconName } from "./icons";

const TONE_ICON: Record<CalloutTone, IconName> = {
  info: "info",
  warn: "alert",
  bad: "x-circle",
  ok: "check",
};

export type CalloutTone = "info" | "warn" | "bad" | "ok";

/** A one-line note or banner in the page flow: what's happening, and the
 * one action that answers it. */
export function Callout({
  tone = "info",
  icon,
  title,
  action,
  role,
  children,
}: {
  tone?: CalloutTone;
  icon?: IconName | React.ReactNode;
  title?: React.ReactNode;
  action?: React.ReactNode;
  role?: "status" | "note" | "alert";
  children?: React.ReactNode;
}) {
  const mark =
    icon == null || typeof icon === "string" ? (
      <Icon
        name={(icon as IconName | undefined) ?? TONE_ICON[tone]}
        size={16}
      />
    ) : (
      icon
    );
  return (
    <div className={`ds-callout ${tone}`} role={role}>
      <span className="ds-callout-mark" aria-hidden>
        {mark}
      </span>
      <div className="ds-callout-text">
        {title && <div className="ds-callout-title">{title}</div>}
        {children && <div className="ds-callout-body">{children}</div>}
      </div>
      {action && <div className="ds-callout-action">{action}</div>}
    </div>
  );
}
